import { render } from "./LoginBlackImage.vue?vue&type=template&id=324c4421"
import script from "./LoginBlackImage.vue?vue&type=script&scoped=true&lang=js"
export * from "./LoginBlackImage.vue?vue&type=script&scoped=true&lang=js"

import "./LoginBlackImage.vue?vue&type=style&index=0&id=324c4421&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__